const INSTANCE_OF_SYMBOL = Symbol('instanceof');
export function HasInstanceOfSymbol(_class) {
    return (_class[INSTANCE_OF_SYMBOL] instanceof Set);
}
export function SetInstanceOf(source, destination) {
    const hasInstance = (Symbol.hasInstance in source)
        ? source[Symbol.hasInstance].bind(source)
        : (() => false);
    Object.defineProperty(source, Symbol.hasInstance, {
        configurable: true,
        enumerable: false,
        writable: false,
        value: (instance) => {
            return (instance instanceof destination)
                || hasInstance(instance);
        }
    });
    if (!HasInstanceOfSymbol(destination)) {
        Object.defineProperty(destination, INSTANCE_OF_SYMBOL, {
            value: new Set(),
        });
    }
    destination[INSTANCE_OF_SYMBOL].add(source);
}
export function IsInstanceOf(instance, _class) {
    return (instance instanceof _class) || ((instance.constructor && HasInstanceOfSymbol(instance.constructor))
        ? instance.constructor[INSTANCE_OF_SYMBOL].has(_class)
        : false);
}
//# sourceMappingURL=instanceof.js.map